<div class="container">
  <div>
    <div class="siemens-logo-white-big"></div>
    <button
      class="mat-elevation-z8 login-btn"
      (click)="login()">
      Login
    </button>
  </div>
</div>
